// Use the API subdomain directly
const API_URL = 'https://api.moreflexaviation.com/api';

export const addSubscriber = async (email: string) => {
  try {
    const response = await fetch(`${API_URL}/subscribe`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
      credentials: 'include',
    });

    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.error || 'Failed to subscribe');
    }
    
    return { success: true, data };
  } catch (error) {
    console.error('Mailchimp error:', error);
    throw error;
  }
};